<template>
    <div
        v-for="(date, index) in weeks"
        :key="date"
        class="grid grid-cols-8 items-center bg-default-100 dark:bg-default-600 hover:bg-default-400 dark:hover:bg-default-500 p-3 rounded-md mt-2">
        <span class="font-bold">
            {{ $t(`labels.${date}`) }}
        </span>
        <div class="text-center col-span-6 text-sm flex gap-4">
            <div class="w-full flex flex-wrap items-center gap-4">
                <div
                    v-for="(time, indexT) in getTimeTypeInDate(date, 'inTime')"
                    :key="time"
                    class="px-2 py-1 rounded-lg flex gap-2"
                    :class="{
                        'bg-success-400': time.type === 'inTime',
                        'bg-info-400': time.type === 'overTime',
                        'bg-warning-400': time.type === 'weekend'
                    }">
                    <p class="h-5 leading-5 p-0 m-0 text-white">
                        {{ convertTimeFormat(time.start) }} - {{ convertTimeFormat(time.end) }}
                    </p>
                </div>
            </div>
            <div
                v-if="getTimeTypeInDate(date, 'overTime')?.length"
                class="w-full flex flex-wrap items-center gap-4">
                <div
                    v-for="(time, indexT) in getTimeTypeInDate(date, 'overTime')"
                    :key="time"
                    class="px-2 py-1 rounded-lg flex gap-2"
                    :class="{
                        'bg-success-400': time.type === 'inTime',
                        'bg-info-400': time.type === 'overTime',
                        'bg-warning-400': time.type === 'weekend'
                    }">
                    <p class="h-5 leading-5 p-0 m-0 text-white">
                        {{ convertTimeFormat(time.start) }} - {{ convertTimeFormat(time.end) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  workingTimes: {
    type: Object as PropType<any>,
    required: true
  }
})
const { workingTimes } = toRefs(props)
const weeks = ref(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'])

const getTimeTypeInDate = (date: string, type: string) => {
  return workingTimes.value[date].filter((item: any) => item.type === type) || []
}

const convertTimeFormat = (minuteInDay: number) => {
  try {
    if (minuteInDay === 1440) {
      return '00:00'
    }
    const hour = Math.floor(minuteInDay / 60)
    const minute = minuteInDay % 60

    const formattedHour = hour.toString().padStart(2, '0')
    const formattedMinute = minute.toString().padStart(2, '0')

    return `${formattedHour}:${formattedMinute}`
  } catch (e) {
    return ''
  }
}
</script>
